const subscriptionActions ={
    SUBSCRIPTION_VALUES: 'SUBSCRIPTION_VALUES',
    UPDATE_SUBSCRIPTION_PLAN: 'UPDATE_SUBSCRIPTION_PLAN',
    UPDATE_ORDER_FOR_SUBSCRIPTION: 'UPDATE_ORDER_FOR_SUBSCRIPTION',
    UPDATE_CATTLE_LISTINGS_SUBSCRIPTION: 'UPDATE_CATTLE_LISTINGS_SUBSCRIPTION',
    GET_USER_SUBSCRIPTIONS: 'GET_USER_SUBSCRIPTIONS',
    SET_USER_SUBSCRIPTIONS: 'SET_USER_SUBSCRIPTIONS',
};

export default subscriptionActions;